import { Company } from 'interfaces/company'
import { getHoursFromMinutes } from 'lib/util/date'
import BillingModal from './billing-modal'
import { useState } from 'react'

const classNames = {
  cardItem: 'tw-mb-4 tw-flex tw-items-center tw-justify-between',
  cardWrapper: 'tw-w-1/2 tw-p-4 tw-block tw-overflow-x-auto tw-bg-white tw-rounded-lg tw-shadow-md',
  container: 'tw-container tw-px-3',
  header: 'tw-flex tw-justify-between tw-mb-4',
  wrapper: 'tw-flex tw-w-full tw-flex-col',
}

export default function BillingPage({ company }: { company: Company }) {
  const platformName = company.platform.base ? 'Base' : company.platform.pro ? 'Pro' : 'Not subscribed'
  const [openModal, setOpenModal] = useState(false)

  return (
    <>
      <div className={classNames.wrapper}>
        <div className={classNames.header}>
          <h4>Manage Your Subscription</h4>
        </div>
        <div className={classNames.container}>
          <div className={classNames.cardWrapper}>
            <div className={classNames.cardItem}>
              <strong>Your Subscription</strong>
              <div
                onClick={() => setOpenModal(true)}
                className="tw-text-squash-600 tw-cursor-pointer tw-text-cornflower-500 hover:tw-underline"
              >
                Manage subscription
              </div>
            </div>
            <div className={classNames.cardItem} data-testid="platform">
              <div>Platform</div>
              <div>{platformName}</div>
            </div>
            <div className={classNames.cardItem} data-testid="creative-services">
              <div>Creative services</div>
              <div>{`${getHoursFromMinutes(company.serviceBaseMinutes)} (daily)`}</div>
            </div>
            <div className={classNames.cardItem} data-testid="professional-services">
              <div>Professional services</div>
              <div>Enabled</div>
            </div>
          </div>
        </div>
      </div>
      <BillingModal open={openModal} setOpen={setOpenModal} />
    </>
  )
}
